import React from "react";
import {SvarReadTypeProps} from "./svarReadTypeCompareMap";

export function NummerReadSvar({evalueringSvar}: SvarReadTypeProps) {
    return (<div className={"margin-bottom-m square questions-answered white-svar"}>{evalueringSvar.nummerSvar}</div>)
}
